import React from 'react'
import {Modal} from "react-bootstrap"


function ModalPolityka(props) {
    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="lg"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Legal disclaimer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
            All rights to the entire contents of the Internet service of ORLEN S.A. are reserved.
The user is allowed to download and print whole pages or parts of the Internet
service of ORLEN S.A. unless the user breaches the author's rights or trademark
registration rights of ORLEN. No part of the service shall be copied as a whole or as
a part, transmitted electronically or otherwise, modified, linked or used without prior
written approval by ORLEN S.A.
            </p>
            <p>
            ORLEN S.A. updates the information included in the service regularly, however,
ORLEN S.A. bears no responsibility for the accuracy, topicality and completeness
of the information presented in the service pages. Simultaneously, ORLEN S.A.
reserves the right to amend the whole service or its parts without prior notice. The
risk of the use and application of the information presented in the service is incurred
by the users themselves. ORLEN S.A. does not bear any responsibility for the
damages resulting from the use of the service of ORLEN S.A.
            </p>
          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalPolityka
